module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNMTIgMUwyMS41IDYuNVYxNy41TDEyIDIzTDIuNSAxNy41VjYuNUwxMiAxWk0xMiAxNUMxMy42NTY5IDE1IDE1IDEzLjY1NjkgMTUgMTJDMTUgMTAuMzQzMSAxMy42NTY5IDkgMTIgOUMxMC4zNDMxIDkgOSAxMC4zNDMxIDkgMTJDOSAxMy42NTY5IDEwLjM0MzEgMTUgMTIgMTVaIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/equipment/setting.svg
// module id = fBkY
// module chunks = 215